import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    MyFormData, 
    myAxios, 
    scroll, 
} from "src/components/common/functions";
import ContactForm from "./contactForm";
//--------------------------------------------------------------------------------------------
export default function Detail({
    updateDateTime, 
    contact, 
    history, 
    setCurrentPage, 
}){
    //--------------------------------------------------------------------------------------------
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? ""); // title
    const path2 = decodeURIComponent(path.split("/")[2] ?? ""); // hash | "Add"
    const path3 = decodeURIComponent(path.split("/")[3] ?? ""); // "Edit" | `organizationHashKey`
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const contacts = useMyStore(state => state.contacts);
    const setContacts = useMyStore(state => state.setContacts);
    const contactDetails = useMyStore(state => state.contactDetails);
    const setContactDetails = useMyStore(state => state.setContactDetails);
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    //--------------------------------------------------------------------------------------------
    const currentContact = useMemo(() => contactDetails[contact.contactHashKey]?({...contact, ...contactDetails[contact.contactHashKey]}):contact, [contact, contactDetails]);
    const address = [
        currentContact.street,
        currentContact.city,
        currentContact.state,
        currentContact.postalCode,
        currentContact.country
    ].filter(item => item).join(", ");
    //--------------------------------------------------------------------------------------------
    const [projectsPerPage, setProjectsPerPage] = useState(10);
    const [currentProjectsPage, setCurrentProjectsPage] = useState(1);
    const indexOfLastProject = currentProjectsPage * projectsPerPage;
    const indexOfFirstProject = indexOfLastProject - projectsPerPage;
    const projects = useMemo(() => currentContact?.projects ?? [], [currentContact]);
    const pageNumbers = useMemo(() => Array.from({length: Math.ceil((projects.length ?? 0) / projectsPerPage)}, (_, i) => (i + 1)), [projects.length, projectsPerPage]);
    //--------------------------------------------------------------------------------------------
    const handleAddOpportunity = () => {
        if(currentContact.organizationHashKey === ""){
            window.alert("Select organization for this contact first.");
            return;
        }
        history.push(`/Opportunities/Add/${currentContact.contactHashKey}`);
    }
    const handleEditOpen = () => history.push(`/${path1}/${contact.contactHashKey}/Edit`);
    const deleteContact = async e => {
        if(!window.confirm("Are you sure to delete this contact?")) return;
        const contactHashKey = e.currentTarget.id;
        const formData = new MyFormData();
        formData.append("contactHashKey", contactHashKey);
        //--------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("contacts/deleteContact.php", formData);
        setShowLoader(false);
        if(!res) return;
        //--------------------------------------------------------
        setContacts(contacts.data.filter(contact => contact.contactHashKey !== contactHashKey));
        history.replace(`/${path1}`);
        setCurrentPage(1);
        scroll(null);
    }
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(path2 === "" || (contactDetails[currentContact.contactHashKey] && (updateDateTime["ContactDetails"] === contactDetails.updatedAt))) return 
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("contactHashKey", currentContact.contactHashKey);
            //--------------------------------------------------------
            setShowLoading(true);
            const resContactDetails =  await myAxios("contacts/readContactDetails.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resContactDetails) return;
            //--------------------------------------------------------
            setContactDetails(
                currentContact.contactHashKey, 
                resContactDetails.data, 
                updateDateTime["ContactDetails"]
            );
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
            setShowLoader(false);
        }
    }, [currentContact.contactHashKey, setShowLoader, contactDetails, setContactDetails, updateDateTime, path2])
    //-----------------------------------------------------------------------------
    return(
        showLoading?<div className = "cssLoading border rounded p-4"> Loading...</div>:
        <div className = "border rounded">
            <div className = "cssSeperateWhenWide pl-3 mb-2">
                <table className = "table table-fixed flex-grow-1 maxWidth-50 mr-3">
                    <tbody className = "noTableTopBorder">
                        {currentContact.businessPhone?
                        <tr>
                            <th>Business Phone</th>
                            <td><a href = {"tel:+1" + currentContact.businessPhone.replace(/-/g, "") + (currentContact.extension?`,${currentContact.extension}`:null)}>{currentContact.businessPhone}{currentContact.extension?` Ext. ${currentContact.extension}`:null}</a></td>
                        </tr>
                        :<></>}
                        {currentContact.directNumber?
                        <tr>
                            <th>Direct Number</th>
                            <td><a href = {"tel:+1" + currentContact.directNumber.replace(/-/g, "")}>{currentContact.directNumber}</a></td>
                        </tr>
                        :<></>}
                        {currentContact.directNumber?
                        <tr>
                            <th>Mobile</th>
                            <td><a href = {"tel:+1" + currentContact.mobile.replace(/-/g, "")}>{currentContact.mobile}</a></td>
                        </tr>
                        :<></>}
                        {currentContact.fax?
                        <tr>
                            <th>Fax</th>
                            <td><a href = {"fax:+1" + currentContact.fax.replace(/-/g, "")}>{currentContact.fax}</a></td>
                        </tr>
                        :<></>}
                        {address?
                        <tr>
                            <th>Address</th>
                            <td>{address}</td>
                        </tr>
                        :<></>}
                        {projects.length?
                        <tr id = "projectsTR"> 
                            <th>Projects Requested</th>
                            <td className = "position-relative pb10">
                                {projects.slice(indexOfFirstProject, indexOfLastProject).map((v, i) => 
                                <li key = {i}>
                                    <Link to = {`/Projects/${v.projectHashKey}`}>
                                        {v.projectName}
                                    </Link>
                                </li>)}
                                {!showLoading && projects.length?
                                <Footer
                                    pageSelectId = "projects"
                                    length = {projects.length}
                                    pageNumbers = {pageNumbers}
                
                                    currentPage = {currentProjectsPage}
                                    setCurrentPage = {setCurrentProjectsPage}
                                    itemsPerPage = {projectsPerPage}
                                    setItemsPerPage = {setProjectsPerPage}

                                    parentId = {"projectsTR"}
                                />
                                :null}
                            </td>
                        </tr>
                        :<></>}
                        {currentContact.creatorEmail?
                        <tr>
                            <th>Creator</th>
                            <td>
                                <UserInfo name = {currentContact.creator} email = {currentContact.creatorEmail}/>
                                <span className = "ml-3">{currentContact.dateCreated}</span>
                            </td>
                        </tr>:<></>}
                        {currentContact.updaterEmail?
                        <tr> 
                            <th>Updater</th>
                            <td>
                                <UserInfo name = {currentContact.updater} email = {currentContact.updaterEmail}/>
                                <span className = "ml-3">{currentContact.dateUpdated}</span>
                            </td>
                        </tr>
                        :<></>}
                    </tbody>
                </table>
                <div className = "d-flex flex-column flex-grow-1 maxWidth-50 mr-3">
                    <fieldset className = "border rounded flex-grow-1 px-3">
                        <legend className = "font-weight-bold w-auto px-2 mb-0">Background</legend>
                        <span className = "cssNotes">{currentContact.background}</span>
                    </fieldset>
                </div>
            </div>
            <div className = "text-right m-2">
                <button type = "button" className = "btn btn-warning" onClick = {handleAddOpportunity}>Add Opportunity</button>
                <button type = "button" className = "btn btn-primary ml-2" onClick = {handleEditOpen}>Edit</button>
                <button type = "button" className = "btn btn-danger ml-2" onClick = {deleteContact} id = {currentContact.contactHashKey}>Delete</button>
            </div>
            {path3 === "Edit"?
            <ContactForm
                updateDateTime = {updateDateTime}
                closeIt = {() => history.push(`/${path1}/${contact.contactHashKey}`)}
                history = {history}
                keyword = "Edit"
                {...currentContact} /* exclusive */
            />
            :null}
        </div>
    )
}